import React from "react";
import icon from "./icon.svg";

function ArrowIcon({ className }: { className: string }) {
  return <img className={className} src={icon} />;
}

export { ArrowIcon };
